export enum TableCellAlignmentEnum {
  LEFT,
  CENTER,
  RIGHT,
}
